/**
 * The client's entry point.
 */
import '@babel/polyfill';
import React from 'react';
import createHistory from 'history/createBrowserHistory';
import { BrowserRouter } from 'react-router-dom';
// import { routerReducer, routerMiddleware, ConnectedRouter } from 'react-router-redux';
// import { routerMiddleware, ConnectedRouter, connectRouter } from 'connected-react-router';
import ReactDOM from 'react-dom';
import { StyleRoot } from 'radium';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { init } from './actions/global';
import thunkMiddleware from 'redux-thunk';
import { fromJS } from 'immutable';
import { combineReducers } from 'redux-immutablejs';
import { reducer as form } from 'redux-form/immutable';
import reducer from './reducers';
import { LicenseManager } from '@ag-grid-enterprise/core';
import ReactHighchart from 'react-highcharts';
import { getRoutes } from './routes';
LicenseManager.setLicenseKey('CompanyName=True Prodigy,LicensedApplication=True Prodigy,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=2,LicensedProductionInstancesCount=0,AssetReference=AG-017920,ExpiryDate=16_September_2022_[v2]_MTY2MzI4MjgwMDAwMA==3ef183f5f89590ac0c46a8df0671028f');
ReactHighchart.Highcharts.setOptions({
  credits: {
    enabled: false
  },
  lang: {
    thousandsSep: ','
  }
});

// Enable some stuff during development to ease debugging
if (process.env.NODE_ENV !== 'production') {
  // For dev tool support, attach to window...
  window.React = React;
}

const history = createHistory();
// add the router reducer to the store on the 'routing' key
const rootReducer = combineReducers({
  app: reducer(history),
  // router: connectRouter(history),
  form
});

export function createOurStore (reducers, initialState) {
  const middleware = [];
  // Install thunk middleware
  middleware.push(thunkMiddleware);
  // middleware.push(routerMiddleware(history));
  // Construct our new createStore() function, using given middleware
  const newCreateStore = Reflect.apply(applyMiddleware, null, middleware)(
    createStore
  );
  // Create the store
  if (__DEVELOPMENT__) {
    return newCreateStore(
      reducers,
      initialState,
      window.__REDUX_DEVTOOLS_EXTENSION__ &&
        window.__REDUX_DEVTOOLS_EXTENSION__()
    );
  }
  return newCreateStore(reducers, initialState);
}

async function boot () {
  // Create redux store
  const initialState = fromJS({});
  const store = createOurStore(rootReducer, initialState);

  await store.dispatch(init());
  // Render application
  ReactDOM.render(
    <StyleRoot>
      <Provider store={store}>
        <div>
          <BrowserRouter>{getRoutes(store)}</BrowserRouter>
        </div>
      </Provider>
    </StyleRoot>,
    document.getElementById('root')
  );
}

boot();
